import React, { useRef } from "react";
import {
    Box,
} from "@mui/material";
import Wsp from "../../../contact/Component/Floatingwsp";
import Faq from "../../../../Common/Components/Faq";
import {
    BannerData,
    caroData,
    CircleData,
    DetailInfo,
    TrimData,
    caro3in1Data,
    gridData,
    com3struct,
    Caro3Heading,
    FaqData,
    StepData
} from "./Data";
import Banner from "../../../../Common/Components/Banner";
import Caro from "../../../../Common/Components/Caro";
import CarModel from "../../../../Common/Components/CarModel";
import ShowInterest from "../../../../Common/Container/showintrestCon";
import MeetTheFamily from "../../../../Common/Components/MeetTheFamily";
import DetailedInfo from "../../../../Common/Components/DetailedInfo";
import Caro3in1 from "../../../../Common/Components/3in1caro";
import Gridview from "../../../../Common/Components/Gridview";
import EVShowcase from "../../../../Common/Components/ComEvstruct";
import CarStepper from "../../../../Common/Components/CarStepper";

export default function CarensClavicEv() {

    const showInterestRef = useRef(null);
    return (
        <Box sx={{ overflowX: "hidden" }}>
            <Banner bannerData={BannerData} />
            <Caro trim={caroData} />
            <CarModel
                model="Clavis Ev"
                bgCar={
                    "https://firebasestorage.googleapis.com/v0/b/kiacentral-dcdd7.firebasestorage.app/o/Seltos%2Fint2.mp4?alt=media&token=4111ad1b-e446-42ad-855e-2f81601538a2"
                }
                CircleData={CircleData}
            />
             <CarStepper
                    StepData={StepData}
                    carLink={
                      "https://firebasestorage.googleapis.com/v0/b/kia-central.firebasestorage.app/o/carens-clavis-ev%2FClavis_Desktop%20s%20ev.mp4?alt=media&token=c897b6f2-b948-4b6a-83cd-b059b1041ffd"
                    }
                    stepTimings={[1.0, 2.0, 3.0, 4.0, 5.0, 6.0, 7.0]}
                  />
            <div ref={showInterestRef}>
                <ShowInterest someValue="Clavis EV" />
            </div>
            <Gridview gridData={gridData} />
            <p style={{ fontSize: "10px", textAlign: "center" }}>
                #Disclaimer: The product shown in the visual is for representation purposes only. Color, features, and India specs may vary while releasing</p>
            {/* <Caro3in1 caro3in1Data={caro3in1Data} heading={Caro3Heading} /> */}


            <EVShowcase com3struct={com3struct} />
            <MeetTheFamily TrimData={TrimData} data={CircleData} />
            <DetailedInfo
                DetailInfo={DetailInfo}
                onScrollToInterest={() => {
                    if (showInterestRef.current) {
                        showInterestRef.current.scrollIntoView({ behavior: "smooth" });
                    }
                }}
            />
            <Faq FaqData={FaqData} />
            <Wsp />
        </Box>
    );
}
